import { combineReducers } from 'redux'
// import { reducer as formReducer } from 'redux-form'
// import { reducer as notificationsReducer } from 'reapop'

import reducerAuth from './reducers/reducerAuth'
import reducerCallAPI from './reducers/reducerCallAPI'

import site from './reducers/masterData/site'
import user from './reducers/masterData/user'
import userGroup from './reducers/masterData/userGroup'
import stations from './reducers/masterData/stations'
import reducerReportAPI from './reducers/reducerReportAPI'
import reducerServiceAPI from './reducers/reducerServiceAPI'
import reducerDeviceAPI from './reducers/reducerDeviceAPI'
import reducerCompanyAPI from './reducers/reducerCompanyAPI'
import reducerStationAPI from './reducers/reducerStationAPI'




export default combineReducers({
    authen: reducerAuth.authen,
    callAPI: reducerCallAPI.reducerCallAPI,
    errorList: reducerCallAPI.errorList, //Error list from API
    isLoading: reducerCallAPI.isLoading,
    verify: reducerAuth.verifyLogin,

    sites: site.sites,
    site: site.site,
    siteChangeImg: site.siteChangeImg,
    users: user.users,
    user: user.user,
    userGroups: userGroup.userGroups,
    userGroup: userGroup.userGroup,
    stations: stations.stations,
    station: stations.station,
    report: reducerReportAPI.report,
    reportExportExcel: reducerReportAPI.reportExportExcel,
    serviceStationList: reducerServiceAPI.serviceStationList,
    serviceDeviceList: reducerServiceAPI.serviceDeviceList,
    serviceDeviceKpi: reducerServiceAPI.serviceDeviceKpi,
    deviceFiveMinutesData: reducerServiceAPI.deviceFiveMinutesData,
    kpiStationHourData: reducerServiceAPI.kpiStationHourData,
    kpiStationDayData: reducerServiceAPI.kpiStationDayData,
    kpiStationMonthData: reducerServiceAPI.kpiStationMonthData,
    kpiStationYearData: reducerServiceAPI.kpiStationYearData,
    serviceDeviceKpiDay: reducerServiceAPI.serviceDeviceKpiDay,
    serviceDeviceKpiMonth: reducerServiceAPI.serviceDeviceKpiMonth,
    serviceDeviceKpiYear: reducerServiceAPI.serviceDeviceKpiYear,
    serviceStationRealKpi: reducerServiceAPI.serviceStationRealKpi,
    serviceStationRealKpiForHomeSite: reducerServiceAPI.serviceStationRealKpiForHomeSite,
    allDevice: reducerDeviceAPI.allDevice,
    loadDeviceByPlantCode: reducerDeviceAPI.loadDeviceByPlantCode,
    deviceChangeImg: reducerDeviceAPI.deviceChangeImg,
    loadDeviceGetKPI: reducerDeviceAPI.loadDeviceGetKPI,
    loadDeviceGetKPIDay: reducerDeviceAPI.loadDeviceGetKPIDay,
    loadDeviceGetKPIMonth: reducerDeviceAPI.loadDeviceGetKPIMonth,
    loadDeviceGetKPIYear: reducerDeviceAPI.loadDeviceGetKPIYear,
    allCompany: reducerCompanyAPI.allCompany,
    updateImg: reducerCompanyAPI.updateImg,
    companyById: reducerCompanyAPI.companyById,
    stationHour: reducerStationAPI.stationHour,
    stationDay: reducerStationAPI.stationDay,
    stationMonth: reducerStationAPI.stationMonth,
    stationYear: reducerStationAPI.stationYear,
    apiDataReportAir: site.apiDataReportAir,
    apiDataReportAirWind: site.apiDataReportAirWind,
    apiDataReportAirPressure: site.apiDataReportAirPressure,
    apiDataReportAir17: site.apiDataReportAir17,
    apiDataReportAirWind17: site.apiDataReportAirWind17,
    apiDataReportAirPressure17: site.apiDataReportAirPressure17,
    apiDataReportAirCloud17: site.apiDataReportAirCloud17,
    apiDataReportAirCloud: site.apiDataReportAirCloud,
})



// WEBPACK FOOTER //
// ./src/app/redux/reducers.js